import { render } from "./NotificationsLog.vue?vue&type=template&id=6f9422b6&scoped=true"
import script from "./NotificationsLog.vue?vue&type=script&lang=js"
export * from "./NotificationsLog.vue?vue&type=script&lang=js"

import "./NotificationsLog.vue?vue&type=style&index=0&id=6f9422b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9422b6"]])

export default __exports__